/**
 * Created by claudio iozzia on 27/04/2017.
 */
import {isNullOrUndefined} from "util";
import {removeDuplicate} from "../common/utils";
import {IEntityAlert, ITranslatedObj} from "./common";
import {TranslateService} from "@ngx-translate/core";
import * as R from "ramda";

export class EntityAlert implements IEntityAlert {
  constructor(public info: string[] = [], public warning: string[] = [], public translatedErrors: ITranslatedObj[] = []) {
    this.hasInfo = (info && info.length > 0);
    this.hasError = translatedErrors && translatedErrors.length > 0;
    this.hasWarning = (warning && warning.length > 0);
    this.hasMessage = this.hasInfo || this.hasError || this.hasWarning;
  }

  public hasMessage: boolean = false;
  public hasInfo: boolean = false;
  public hasError: boolean = false;
  public hasWarning: boolean = false;

  public static getTypeName(i: IEntityAlert): string {
    return i.hasError ? "error" : i.hasWarning ? "warning" : i.hasInfo ? "info" : "";
  }

  public static getMessage(i: IEntityAlert, translateService: TranslateService = null): string {
    if (i.hasError) {
      const translateInstant = x => x && x.key ? translateService.instant(`VALIDATION.${x.key}`, x.data || null) : null;
      return translateService && i.translatedErrors && i.translatedErrors.length > 0
        ? R.map(translateInstant, i.translatedErrors).join("; ")
        : translateService.instant('VALIDATION.generic error');
    }
    return i.hasWarning ? i.warning.join("; ") : i.hasInfo ? i.info.join("; ") : "";
  }

  public getTypeName() {
    return EntityAlert.getTypeName(this);
  }

  public getMessage(): string {
    return EntityAlert.getMessage(this);
  }

}

export const EMPTY_ENTITY_ALERT: IEntityAlert = new EntityAlert();

// enum alertType{
//   INFO,
//   WARNING,
//   ERROR
// }

export class EntityInfo extends EntityAlert {
  constructor(str: string = "") {
    const _str: string[] = (isNullOrUndefined(str) || str.trim() === "") ? [] : [str.trim()];
    super(_str);
  }
}

export class EntityWarning extends EntityAlert {
  constructor(str: string = "") {
    const _str: string[] = (isNullOrUndefined(str) || str.trim() === "") ? [] : [str.trim()];
    super([], _str);
  }
}

export class EntityError extends EntityAlert {
  constructor(obj: ITranslatedObj = null) {
    const _obj: ITranslatedObj[] = obj && obj.key ? [obj] : [];
    super([], [], _obj);
  }
}

export function composeEntityAlert(arr: IEntityAlert[]): IEntityAlert {
  return arr.reduce((acc: IEntityAlert, c: IEntityAlert) => {
    return new EntityAlert(
      acc.info.concat(c.info),
      acc.warning.concat(c.warning),
      acc.translatedErrors.concat(c.translatedErrors));
  }, EMPTY_ENTITY_ALERT);
}


export function reduceEntityAlert(a: IEntityAlert): IEntityAlert {
  return new EntityAlert(
    removeDuplicate<string>(a.info),
    removeDuplicate<string>(a.warning),
    a.translatedErrors);
}
